export * from './IconComponent';
